import { CardMedsusItem } from './cardMedsusItem';
import { IMedsusCard } from './cardMedsusItem';

interface CardMedsusProps {
  items: IMedsusCard[];
  onCardClick?: (id: string) => void;
}

export function CardMedsus({ items, onCardClick }: CardMedsusProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: '20px',
        marginBottom: '100px',
        gap: '20px',
        width: '100%',
      }}
    >
      {items.map((item) => (
        <CardMedsusItem key={item.id} data={item} onClick={onCardClick} />
      ))}
    </div>
  );
}
